import * as types from '../mutation_types';
import router from '@views/home/router';
import axios from 'axios';

const debug = false;
const debugGetCalendar = debug;

export default {
  getCalendar({commit, state, dispatch, rootState}) {
    return new Promise((resolve, reject) => {
      dispatch('setLoading', true, {root: true});

      let call;
      if (debugGetCalendar) {
        call = import('@fixtures/calendar-fixture');
      } else {
        const token = router.app.$context.token;
        call = axios.get('/api/v1/calendar/', {
          headers: {
            Authorization: `Token ${token}`
          }
        });
      }
      call.then(response => {
        dispatch('calendar/setCalendar', response.data, {root: true});
        resolve(response.data);
        dispatch('setLoading', false, {root: true});
      }).catch(err => {
        reject(err);
        dispatch('setLoading', false, {root: true});
      });
    });
  },
  setCalendar({commit}, payload) {
    return new Promise((resolve, reject) => {
      try {
        commit(types.SET_CALENDAR, payload);
        resolve();
      } catch (e) {
        console.log(e);
        reject(e);
      }
    });
  },
  deleteBooking({commit, state, dispatch, rootState}, payload) {
    return new Promise((resolve, reject) => {
      dispatch('setLoading', true, {root: true});

      const token = router.app.$context.token;
      let call;
      if (payload.entity === 'workstation') {
        call = axios.delete(`/api/v1/workstation-reservation/${payload.booking_id}/`, {
          headers: {
            Authorization: `Token ${token}`
          }
        });
      } else if (payload.entity === 'colleague_workstation') {
        call = axios.delete(`/api/v1/colleague-workstation-reservation/${payload.booking_id}/`, {
          headers: {
            Authorization: `Token ${token}`
          }
        });
      } else if (payload.entity === 'parking_space') {
        call = axios.delete(`/api/v1/parking-space-reservation/${payload.booking_id}/`, {
          headers: {
            Authorization: `Token ${token}`
          }
        });
      }
      call.then(response => {
        resolve(response.data);
        dispatch('setLoading', false, {root: true});
      }).catch(err => {
        reject(err);
        dispatch('setLoading', false, {root: true});
      });
    });
  }
};
